export default __webpack_public_path__ + "static/media/precise-location-ss-selected.9e1652b6.svg";